import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'diana-confirmation-input',
    templateUrl: './confirmation-input.component.html',
    styleUrls: ['./confirmation-input.component.scss'],
    standalone: false
})
export class ConfirmationInputComponent {

  @Input() title!: string;
  @Input() name = '';
  @Input() body = '';
  @Output() clickResult = new EventEmitter<boolean>();

  constructor() { }

  public clickEvent(result: boolean): void {
    this.clickResult.emit(result);
  }

}
